


















































import Api from "./Api";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import CompanyUserRequired from "../../CompanyRequired";
import {CardExpirationReportRow} from "@/components/users/reports/CardExpirationReportModel";
import {Company, DateTime} from "@/modules/models";
import rd from "@/modules/vRoutedefs";
import DatePicker from "@/components/DatePicker.vue";

@Component({
  components: {
    "at-date-picker": DatePicker,
  }
})
export default class CardExpirationReportLocations extends CompanyUserRequired {
    @Inject()
    api!: Api;
    @Prop({default: () => DateTime.now().dayOffset(1)} /* default is next day */)
    maxExpiration!: DateTime;
    @Prop({default: () => DateTime.now().dayOffset(-7)} /* default is one week ago */)
    minTimeIn!: DateTime;

    get maxEx() {
      return this.maxExpiration;
    }
    set maxEx(v: DateTime) {
      if(!v.equals(this.maxExpiration)) {
        this.$router.push({ path: rd.users.reports.cardexpirationlocation.path, query: {"max-expiration": v.toDayParam(), "min-time-in": this.minTimeIn.toDayParam()} });
      }
    }
    get minTim() {
      return this.minTimeIn;
    }
    set minTim(v: DateTime) {
      if(!v.equals(this.minTimeIn)) {
        this.$router.push({ path: rd.users.reports.cardexpirationlocation.path, query: {"max-expiration": this.maxExpiration.toDayParam(), "min-time-in": v.toDayParam()} })
      }
    }


    loading = false;

    headers = [
        {"text": "Kortnr", value: "cardNum", align: "left"},
        {"text": "Utløpsdato", value: "expirationDate", align: "left"},
        {"text": "Firma", value: "cardCompany", align: "left"},
        {"text": "Fornavn", value: "firstName", align: "left"},
        {"text": "Etternavn", value: "lastName", align: "left"},
        {"text": "Mobilnr", value: "phone", align: "left"},
        {"text": "Sist innregistrert", value: "lastTimeIn", align: "left"},
        {"text": "Anlegg", value: "terminalLocation", align: "left"},
    ];

    items: CardExpirationReportRow[] = [];

    pagination = {
        rowsPerPage: -1,
        sortBy: "cardCompany"
    };

    // List of companies in result. So that we can offer to filter on them
    get distinctCompanies(): Company[] {
        let companies = this.items.map((r: CardExpirationReportRow) => r.cardCompany).filter((c: Company, i: number, self: Company[]) => self.indexOf(c) == i);
        if(this.filterCompany != null) { // add filterCompany so its displayed in the select, and clearable there.
            companies.push(this.filterCompany);
        }
        return companies;
    }
    // if user choose to filter on a company, this is set
    filterCompany: Company | null = null;
    set filterOrgNum(num: number) {
        if(num > 0) {
            this.filterCompany = this.distinctCompanies.find((c: Company) => c.orgNum === num) || null;
        } else {
            this.filterCompany = null;
        }
    }
    get filterOrgNum() {
        return this.filterCompany != null ? this.filterCompany.orgNum : 0;
    }

    get filteredItems() {
        if(this.filterOrgNum > 0) {
            return this.items.filter(r => r.cardCompany.orgNum === this.filterOrgNum);
        }
        return this.items;
    }

    @Watch("minTim")
    @Watch("maxEx")
    async loadResult() {
        this.loading = true;
        try {
            this.items = await this.api.fetchCardExpirationReportCompanyLocations(this.company.orgNum, this.maxExpiration, this.minTimeIn);
        } catch (err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    expirationClass(expirationDate: DateTime) {
        if(expirationDate.isBefore(DateTime.now())) {
            return "error--text";
        } else {
            return "warning--text";
        }
    }

    userTo(personGuid: string) {
        return {name: rd.users.name, query: {guid: personGuid}};
    }

    created() {
        this.loadResult();
    }
}
